import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import Services from "../components/site/Services";
import WhyUs from "../components/site/WhyUs";
import Testimonials from "../components/site/Testimonials";
import BookingForm from "../components/site/BookingForm";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyUs />
        <Testimonials />
        <BookingForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
